import 'braid-design-system/reset';

import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import fetch from 'cross-fetch';

import {
  getBrand,
  getCountryCode,
  getEnvironment,
} from 'src/core/config/globalStates';

import { getAuthentication } from '../authentication/authentication';

const getGraphEndpoint = () => {
  const environment = getEnvironment();
  if (environment !== 'staging') {
    return `https://www.seek.com.au/graphql`;
  }
  return `https://www.staging.seek.com.au/graphql`;
};

const httpLink = createHttpLink({
  uri: getGraphEndpoint(),
  fetch,
});

const headerLink = setContext(async (_, { headers }) => {
  const newHeaders = {
    ...headers,
    'seek-request-country': getCountryCode(),
    'seek-request-brand': getBrand(),
  };

  const auth = await getAuthentication(true);
  if (auth && auth.token) {
    newHeaders.authorization = `Bearer ${auth.token}`;
  }

  return {
    headers: newHeaders,
  };
});

export const client = new ApolloClient({
  link: headerLink.concat(httpLink),
  cache: new InMemoryCache({
    typePolicies: {
      SeekMaxPollOption: {
        keyFields: false,
      },
    },
  }),
});
